import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, label, dark = false }) => (
  <div className="flex items-center gap-3" data-testid={`chapter-${label.toLowerCase().replace(/\s+/g, "-")}`}>
    <span className={`font-mono text-xs font-semibold tracking-[0.25em] ${dark ? "text-gold" : "text-gold-dark"}`}>
      {index}
    </span>
    <span className={`h-px w-10 ${dark ? "bg-gold/50" : "bg-gold-dark/40"}`} />
    <span
      className={`font-mono text-xs uppercase tracking-[0.25em] ${
        dark ? "text-emerald-100/60" : "text-forest/60"
      }`}
    >
      {label}
    </span>
  </div>
);

export const SectionHeading = ({ chapter, title, subtitle, dark = false, center = false }) => (
  <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <div className={center ? "flex justify-center" : ""}>
        <Chapter index={chapter[0]} label={chapter[1]} dark={dark} />
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`mt-5 font-display text-2xl font-bold tracking-tight text-balance sm:text-3xl lg:text-4xl ${
          dark ? "text-bone" : "text-forest-deep"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.16}>
        <p className={`mt-4 text-base leading-relaxed sm:text-lg ${dark ? "text-emerald-100/70" : "text-muted-foreground"}`}>
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
